<template>
  <v-app>
    <section class="section-edit notification-viewer">
      <h2>See Notification '{{ notification.title }}'</h2>

      <!-- PANNEAU COMMON -->
      <v-card class="mx-auto mt-8">
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="headline mb-1">Common</v-list-item-title>
            <v-list-item-subtitle>Title : {{ notification.title }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-img            
            class="notification-icon"
            contain
            v-if="notification.iconUrl"
            max-height="80"
            max-width="80"
            :src=notification.iconUrl
          />
        </v-list-item>
      </v-card>

      <!-- PANNEAU TRANSLATIONS -->
      <v-card class="mt-8" v-for="(translation, id) in notification.translations" :key="id">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="headline mb-1">{{ getLanguage(translation.langageId) }}</v-list-item-title>
            <v-card-text>
              <ul>
                <li>Notification title : {{ translation.title }}</li>
                <li class="mt-2">Notification content : {{ translation.description }}</li>
              </ul>
            </v-card-text>
          </v-list-item-content>
        </v-list-item>
      </v-card>

      <!-- PANNEAU USER GROUPS -->
      <v-card class="mx-auto mt-8">
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="headline mb-1">Sent to these UserGroups</v-list-item-title>
            <div v-if="notification.typeValue && notification.typeValue.length > 0">
              <v-list-item-subtitle v-for="(group, index) in notification.typeValue" :key="`${group.usergroupId}-${index}`">{{ group.title }}</v-list-item-subtitle>
            </div>
            <div v-else>
              <v-list-item-subtitle>Not sent to any group</v-list-item-subtitle>
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-card>

      <p v-if="notification.usergroupTitle" class="sent-to mt-6">
        Sent to <span @click="redirectToUserGroup(notification.usergroupId)">'{{ notification.usergroupTitle }}'</span>
      </p>

      <v-btn
        @click="redirectToBack"
        width="250"
        class="btn mt-5"
        color="error"
      >
        <v-icon dark left>mdi-arrow-left</v-icon>
        Back
      </v-btn>
    </section>
  </v-app>
</template>

<script>
  import notificationsApi from '@/services/api/notifications-api';
  import userGroupsApi from '@/services/api/user-groups-api';

  export default {
    name: 'NotificationViewer',

    props: ['id'],

    data: () => ({
      notification: {
        title: null,
        iconUrl: null,
        sentTo: null,
        translations: []
      }
    }),

    async mounted() {
      // Chargement de toutes les notifications
      let data = await notificationsApi.getSingleNotification(this.$route.params.id);
      this.notification = data.data;

      // Récupération des usergroup
      this.notification.typeValue = await Promise.all(JSON.parse(data.data.typeValue).map(async (groupId) => {
        const usergroup = await userGroupsApi.getSingleUserGroup(groupId);

        return usergroup.data.data;
      }));
    },

    methods: {
      redirectToBack() {
        this.$router.back();
      },

      getLanguage(id) {
        switch (id) {
          case 1: return 'English (en)';
          case 2: return 'Danish (da)';
          case 3: return 'German (de)';
          case 4: return 'Spanish (es)';
          case 5: return 'French (fr)';
          case 6: return 'Hungarian (hu)';
          case 7: return 'Italian (it)';
          case 8: return 'Dutch (nl)';
          case 9: return 'Polish (po)';
          default: return 'English (en)';
        }
      },

      redirectToUserGroup(id) {
        this.$router.push({ name: 'UpdateUserGroup', params: { id } });
      }
    }
  };
</script>

<style lang="scss">
  @import "./index";
</style>
